import { __awaiter, __generator } from "tslib";
import { logger } from '../../../logger';
export var registerSleeknote = function (analytics, options) {
    var sleeknoteOptions = typeof options.sleeknote === 'object' ? options.sleeknote : {};
    document.addEventListener('sleekNote', function (rawEvent) { return __awaiter(void 0, void 0, void 0, function () {
        var event, eventName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event = rawEvent;
                    if (!(event.data.type == 'submit')) return [3 /*break*/, 3];
                    logger.debug('Received Sleeknote submit event');
                    return [4 /*yield*/, analytics.identify(null, {
                            email: event.data.email,
                        })];
                case 1:
                    _a.sent();
                    eventName = sleeknoteOptions.eventName || 'Sleeknote popup';
                    return [4 /*yield*/, analytics.track(eventName)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, false);
};
//# sourceMappingURL=index.js.map